import { detailInfo, submitApproval } from './../api';
const rejectApprovalShow = {
  namespaced: true,
  state: {
    detailInfoObj: null,
    submitApprovalObj: null
  },
  mutations: {
    DETAIL_INFO(state, data) {
      state.detailInfoObj = data;
    },
    SUBMIT_APPROVAL(state, data) {
      state.submitApprovalObj = data;
    }
  },
  actions: {
    async detailInfo({ commit }, obj) {
      let resp = await detailInfo(obj);
      commit('DETAIL_INFO', resp);
    },
    async submitApproval({ commit }, obj) {
      let resp = await submitApproval(obj);
      commit('SUBMIT_APPROVAL', resp);
      return resp;
    }
  }
}
export default rejectApprovalShow



// WEBPACK FOOTER //
// ./src/page/reject/rejectApprovalShow/store/rejectApprovalShow.store.js